import { render } from "./ObjectCopyFields.vue?vue&type=template&id=178ba39e"
import script from "./ObjectCopyFields.vue?vue&type=script&lang=js"
export * from "./ObjectCopyFields.vue?vue&type=script&lang=js"

import "./ObjectCopyFields.vue?vue&type=style&index=0&id=178ba39e&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.12.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__